module.exports = __webpack_public_path__ + "static/media/final1.0542f07b.jpg";